import { all, fork } from 'redux-saga/effects';

import watchGetProductsPaginated from './getProductsPaginated';
import watchGetRecommendations from './getRecommendations';

function* recommendationSagas() {
  yield all([fork(watchGetRecommendations), fork(watchGetProductsPaginated)]);
}

export default recommendationSagas;
